import { render, staticRenderFns } from "./legend-pie.vue?vue&type=template&id=6da98ab2&scoped=true"
import script from "./legend-pie.vue?vue&type=script&lang=js"
export * from "./legend-pie.vue?vue&type=script&lang=js"
import style0 from "./legend-pie.vue?vue&type=style&index=0&id=6da98ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da98ab2",
  null
  
)

export default component.exports